import type {GetTabsArg} from '../services/rest'
import type {TabParamsKey} from '../types'

export const getTabsArg = (key: TabParamsKey, cacheTabs = true, essential = true): GetTabsArg => ({
  key,
  cacheTabs,
  essential,
})
